<template>
  <section>
    <v-client-table
      :data="echeanciers"
      :columns="columns"
      :options="options">
      <template slot="bailleur" slot-scope="props">
        {{ props.row.tiers.nomCommercial }}
      </template>
      <template slot="debut" slot-scope="props">
        {{ props.row.debutPeriode | formatDate }}
      </template>
      <template slot="fin" slot-scope="props">
        {{ props.row.finPeriode | formatDate }}
      </template>
      <template slot="montantHt" slot-scope="props" >
        <div class="is-pulled-right">
        {{ props.row.montantHt | formatDevise }}
        </div>
      </template>
      <template slot="montantHtIndexe" slot-scope="props">
        <div class="is-pulled-right">
          {{ calculMontantIndexe(props.row, props.row.montantHt) | formatDevise }}
        </div>
      </template>
      <template slot="infos" slot-scope="props">
        <b-tooltip
          class="width-100percent"
          :label="$t('detailContrat.indexation.echeancierNonIndexable')"
          multiline
          type="is-warning"
          position="is-left"
          v-if="!isModifiable(props.row.etat)">
          <b-icon
            icon="alert"
            custom-size="mdi-24px"
            type="is-warning">
          </b-icon>
        </b-tooltip>
      </template>
    </v-client-table>
  </section>
</template>

<script>
import cloneDeep from 'lodash/cloneDeep';
import {
  NO_PER_PAGE_VALUE, RESULTS_PER_POP_UP, SORT_ICON, TEXTS,
} from '@/configuration/clientTableConf';
import {
  ECHEANCE_ENREGISTRER,
  ECHEANCE_BROUILLON,
} from '@/configuration/baux/contrat/echeancier/echeancier';
import calculMontantIndexe from '@/services/baux/contrat/indexation';

export default {
  props: {
    contrat: {
      type: Object,
      required: true,
    },
    payload: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
    };
  },
  computed: {
    columns() {
      return [
        'bailleur',
        'debut',
        'fin',
        'montantHt',
        'montantHtIndexe',
        'infos',
      ];
    },
    options() {
      const texts = cloneDeep(TEXTS);
      texts.count = '';
      return {
        sortIcon: SORT_ICON,
        headings: {
          bailleur: this.$t('ajoutEditContrat.echeancier.tabEcheance.bailleur'),
          debut: this.$t('ajoutEditContrat.echeancier.tabEcheance.debut'),
          fin: this.$t('ajoutEditContrat.echeancier.tabEcheance.fin'),
          montantHt: this.$t('ajoutEditContrat.echeancier.tabEcheance.montantHt'),
          montantHtIndexe: this.$t('ajoutEditContrat.echeancier.tabEcheance.montantHtIndexe'),
          infos: '',
        },
        sortable: [],
        texts: texts,
        filterable: false,
        perPageValues: NO_PER_PAGE_VALUE,
        perPage: RESULTS_PER_POP_UP,
      };
    },
    echeanciers() {
      return this.contrat.echeancier
        .filter(el => el.debutPeriode >= this.payload.dateIndexation);
    },
  },
  methods: {
    calculMontantIndexe(ech) {
      ech.typeIndexation = this.contrat.typeIndexation;
      ech.valeurIndexationActuel = this.payload.valeurIndexationActuel;
      ech.valeurIndexationReference = this.contrat.valeurIndexationReference;
      if (ech.montantIndexationReference === null) ech.montantIndexationReference = ech.montantHt;
      return calculMontantIndexe(ech, ech.montantHt);
    },
    isModifiable(etat) {
      return (etat === ECHEANCE_ENREGISTRER || etat === ECHEANCE_BROUILLON);
    },
  },
};
</script>
